import { TableFilterConfig } from '@/components/data-table/filters-v2';
import i18n from '@/core/i18n';
import { DEFAULT_PAGE_SIZE_PROJECTS_SHORT_ENTITIES } from '@/lib/constants/pagination';
import { EntityAvatar } from '@/modules/common';
import { CustomAttribute } from '@/modules/common/types/custom-attribute';
import { buildCustomAttributeFilterConfigsV2 } from '@/modules/common/utils/custom-attribute-filters';
import { getShortProjects } from '@/modules/projects';
import { renderProjectFilterLabel } from '@/modules/projects/helpers/project-dropdown-option';
import { getShortTeamMembers } from '@/modules/team';

import {
  BILLS_FILTER_KEY_MEMBER,
  BILLS_FILTER_KEY_PROJECT,
  BILLS_FILTER_KEY_SEARCH,
} from './bills-filter-keys';

export const SEARCH_FILTER_MIN_CHARACTERS = 2;

export const getGenerateBillsFiltersConfig = (
  customAttributes?: CustomAttribute[]
): TableFilterConfig[] => [
  {
    type: 'search',
    name: BILLS_FILTER_KEY_SEARCH,
    label: i18n.t('authenticated.bills:new.filters.search.label'),
    placeholder: i18n.t('authenticated.bills:new.filters.search.placeholder'),
    minCharacters: SEARCH_FILTER_MIN_CHARACTERS,
    saveable: false,
  },
  {
    type: 'dynamic-autocomplete',
    name: BILLS_FILTER_KEY_MEMBER,
    label: i18n.t('authenticated.bills:filters.memberName'),
    withSearch: true,
    loadOptions: params =>
      getShortTeamMembers({
        filter: { searchString: params.searchString },
        pagination: {
          cursor: params.cursor,
          pageSize: params.pageSize ?? DEFAULT_PAGE_SIZE_PROJECTS_SHORT_ENTITIES,
        },
      }),
    renderLabel: (value, option) => (
      <div className="flex items-center gap-2">
        <EntityAvatar image={option.avatar} name={value} size="xs" shape="circle" />
        <span className="text-sm">{value}</span>
      </div>
    ),
    order: 1,
  },
  {
    type: 'dynamic-autocomplete',
    name: BILLS_FILTER_KEY_PROJECT,
    label: i18n.t('authenticated.bills:filters.project'),
    withSearch: true,
    loadOptions: params =>
      getShortProjects({
        filter: { searchString: params.searchString },
        pagination: {
          cursor: params.cursor,
          pageSize: params.pageSize ?? DEFAULT_PAGE_SIZE_PROJECTS_SHORT_ENTITIES,
        },
      }),
    renderLabel: renderProjectFilterLabel,
    order: 2,
  },
  ...(customAttributes
    ? buildCustomAttributeFilterConfigsV2(customAttributes, 3, {
        noValueOptionLabel: i18n.t('common:tableFilters.noAttributeValue'),
      })
    : []),
];
